import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import TasimaYemek from "./pages/TasimaYemek";
import Menu from "./pages/Menu";
import About from "./pages/About";
import Contact from "./pages/Contact";
import LezzetSirlari from "./pages/LezzetSirlari";
import LezzetSirlariMakale from "./pages/LezzetSirlariMakale";
import Sertifikalar from "./pages/Sertifikalar";
import NotFound from "./pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const DEFAULT_TITLE =
  'Tarhun Catering — Kurumsal Taşıma Yemek Hizmeti | Kocaeli · İstanbul · Sakarya';

const TITLES = [
  { match: (p) => p === '/', title: DEFAULT_TITLE },
  { match: (p) => p === '/tasima-yemek', title: 'Taşıma Yemek Hizmeti — Tarhun Catering' },
  { match: (p) => p === '/hakkimizda',   title: 'Kurumsal · Başkanın Mesajı — Tarhun Catering' },
  { match: (p) => p === '/sertifikalar', title: 'Sertifikalar · HACCP & ISO 22000 — Tarhun Catering' },
  { match: (p) => p === '/lezzet-sirlari', title: 'Lezzet Sırları · Tarhun Defteri — Tarhun Catering' },
  { match: (p) => p.startsWith('/lezzet-sirlari/'), title: 'Makale · Lezzet Sırları — Tarhun Catering' },
  { match: (p) => p === '/iletisim',     title: 'İletişim · 48 Saat İçinde Teklif — Tarhun Catering' },
];

const PageTitle = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const found = TITLES.find((t) => t.match(pathname));
    document.title = found ? found.title : DEFAULT_TITLE;
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    // Defensive: remove any third-party-injected badges or branding overlays.
    const removeBadge = () => {
      const sels = [
        '#emergent-badge',
        'a[href*="emergent.sh"][target="_blank"]',
        'a[id*="emergent-badge"]',
      ];
      sels.forEach((s) => {
        document.querySelectorAll(s).forEach((el) => el.remove());
      });
    };
    removeBadge();
    const obs = new MutationObserver(removeBadge);
    obs.observe(document.body, { childList: true, subtree: true });
    const interval = setInterval(removeBadge, 1500);
    return () => {
      obs.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageTitle />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tasima-yemek" element={<TasimaYemek />} />
          <Route path="/hizmetler" element={<Navigate to="/tasima-yemek" replace />} />
          <Route path="/hizmetler/:slug" element={<Navigate to="/tasima-yemek" replace />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/lezzet-sirlari" element={<LezzetSirlari />} />
          <Route path="/lezzet-sirlari/:slug" element={<LezzetSirlariMakale />} />
          <Route path="/sertifikalar" element={<Sertifikalar />} />
          <Route path="/sertifikalarimiz" element={<Navigate to="/sertifikalar" replace />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/referanslar" element={<Navigate to="/iletisim" replace />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
